import React, { useState, useEffect,useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Segment,
  Header,
  Checkbox,
  Button,
  Message,
  Divider,
  Icon,
} from 'semantic-ui-react';

const Quiz = ({ data, endQuiz,userInfo }) => {
  const sortedData = useMemo(() => {
    return [...data]
      .sort((a, b) => a.id - b.id)
      .map(q => ({
        ...q,
        options: [...(q.options || [])].sort((a, b) => a.id - b.id),
      }));
  }, [data]);

  const [questionIndex, setQuestionIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [answers, setAnswers] = useState([]);

  const currentQuestion = sortedData[questionIndex];
  useEffect(() => {
    if (questionIndex > 0) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [questionIndex]);

  useEffect(() => {
    if (!currentQuestion || currentQuestion.options.length === 0) {
      const autoAnswer = {
        question: currentQuestion?.title || '',
        selectedTexts: [],
        selectedOptionIds: [],
        selectedPersonType: currentQuestion?.options.personality_type_id || '',
      };
      const updatedAnswers = [...answers, autoAnswer];

      if (questionIndex === data.length - 1) {
        endQuiz({
          totalQuestions: data.length,
          questionsAndAnswers: updatedAnswers,
        });
      } else {
        setAnswers(updatedAnswers);
        setQuestionIndex(questionIndex + 1);
        setSelectedOptions([]);
      }
    }
  }, [currentQuestion]);

  const toggleOption = (option) => {
    const exists = selectedOptions.some((o) => o.id === option.id);
    if (exists) {
      setSelectedOptions((prev) => prev.filter((o) => o.id !== option.id));
    } else {
      setSelectedOptions((prev) => [...prev, option]);
    }
  };

  const handleNext = () => {
    const selectedOptionIds = selectedOptions.map((opt) => opt.id);
    const selectedTexts = selectedOptions.map((opt) => opt.text);
    const selectedPersonType = selectedOptions.map((opt) => opt.personality_type_id);
    const answer = {
      question: currentQuestion?.question || '',
      selectedTexts,
      selectedOptionIds,
      selectedPersonType: selectedPersonType[0],
    };

    const updatedAnswers = [...answers, answer];

    if (questionIndex === data.length - 1) {
      endQuiz({
        totalQuestions: data.length,
        questionsAndAnswers: updatedAnswers,
      });
    } else {
      setAnswers(updatedAnswers);
      setQuestionIndex(questionIndex + 1);
      setSelectedOptions([]);
    }
  };

  const visibleOptions = currentQuestion?.options?.filter(opt => !opt.is_tiebreaker) || [];
  return (
    <Container>
      <Segment padded>
        <Header as="h2" textAlign="center">
          Soru {questionIndex + 1} / {data.length}
        </Header>
        <Message floating size="large" icon>
  <Icon name="question circle outline" />
  <Message.Content>
  <Message.List>
    <Message.Item><strong>İsim:</strong> {userInfo.full_name}</Message.Item>
    <Message.Item><strong>Email:</strong> {userInfo.email}</Message.Item>
  </Message.List>

  <Divider />

  <div style={{
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#555',
    padding: '0.5rem 1rem',
    maxWidth: '100%',
    wordBreak: 'break-word',
  }}>
    <p>
      Her cümle size yakın gelebilir. Çünkü bu ifadeler sizde az ya da çok bulunur.
    </p>
    <p>
      <strong>Aşağıdaki ifadelerden sizi %100 TANIMLAYAN ifadeleri işaretlemenizi istiyoruz.</strong>
      <strong style={{ marginLeft: '0.3rem' }}> BİRDEN FAZLA İFADE </strong> işaretleyebilirsiniz.
    </p>
    <p>
      Ancak <strong>sizi AZ TANIMLAYAN</strong> İFADELERİ İŞARETLEMEYİNİZ.
    </p>
    <p>
      Her ifadenin sizde var olabileceğini hatırlatalım ama amacınız <em>sizi en iyi tanımlayan ifadeleri</em> bulmak. 😊
    </p>
  </div>
</Message.Content>

</Message>


        <Divider />

        {visibleOptions.length === 0 ? (
          <Message warning>
            Bu sorunun seçenekleri tanımlanmamış. Otomatik olarak geçiliyor...
          </Message>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {visibleOptions.map((option) => (
              <Checkbox
                key={option.id}
                label={
                  <label style={{ fontWeight: 'bold', cursor: 'pointer' }}>
                    {option.text}
                  </label>
                }                
                checked={selectedOptions.some((o) => o.id === option.id)}
                onChange={() => toggleOption(option)}
              />
            ))}
          </div>
        )}

        {visibleOptions.length > 0 && (
          <Button
            primary
            fluid
            size="large"
            disabled={selectedOptions.length === 0}
            onClick={handleNext}
            style={{ marginTop: '2rem' }}
          >
            {questionIndex === data.length - 1 ? 'Bitir' : 'İleri'}
          </Button>
        )}
      </Segment>
    </Container>
  );
};

Quiz.propTypes = {
  data: PropTypes.array.isRequired,
  endQuiz: PropTypes.func.isRequired,
};

export default Quiz;